
<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2>{{$t('certificates.expires_date_from_to')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.from')}}
                        <el-form-item prop="expires_from">
                            <el-date-picker
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.expires_from.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaAltaD"
                              @blur="onBlurDatePickerMixin('.datePickerFechaAltaD-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaAltaD-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaAltaD-popover"
                              >
                            </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.to')}}
                        <el-form-item prop="expires_to">
                          <el-date-picker
                            class="bg-white dark:bg-darkblue-900"
                            v-model="form.expires_to.value"
                            :picker-options="dateRangeOptions"
                            type="date"
                            format="dd-MM-yyyy"
                            placeholder="dd-mm-aaaa"
                            ref="datePickerFechaAltaH"
                            @blur="onBlurDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @focus="onBlurDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @keydown.native="captureKeyNotChrome"
                            popper-class="datePickerFechaAltaH-popover"
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>

              <AccessibleElSelect
                v-model="form.tipoCert.value"
                prop="tipoCert"
                :options="tiposCertificadoForAccessibleSelect"
                :withFormItem="true"
                id-prefix="companycertificatesfilter"
              >
                <template slot="label">{{$t('certificates.type')}}</template>
              </AccessibleElSelect>

            <div>
              <span id="company-certs-filter-name-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.name')}}</span>
              <el-form-item prop="name">
                <el-input
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                  aria-labelledby="company-certs-filter-name-label"
                >
                  <template v-if="form.name.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de nombre"
                      @clear="form.name.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="company-certs-filter-serial-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.serial')}}</span>
              <el-form-item prop="serial">
                <el-input
                  class="w-full"
                  v-model="form.serial.value"
                  maxlength="100"
                  aria-labelledby="company-certs-filter-serial-label"
                >
                  <template v-if="form.serial.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de serial"
                      @clear="form.serial.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>
<script>
// import _ from 'lodash'
import { TIPOS_CERT } from '@/config/tipos-cert'
import moment from 'moment'
import { i18n } from '@/i18n'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      vuexnamespace: 'companyothercertificates',
      tiposCertificado: TIPOS_CERT,
      distribuidores: [],
      clientes: [],
      form: {
        expires_from: { label: 'Expira desde', value: '' },
        expires_to: { label: 'Expira hasta', value: '' },
        name: { label: 'Nombre', value: '' },
        serial: { label: 'Serial', value: '' },
        tipoCert: { label: i18n.t('certificates.type'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposCertificadoForAccessibleSelect: function () {
      return this.tiposCertificado.map(item => ({
        id: item.id,
        name: item.name
      }))
    }
  },
  mounted: async function () {
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.serial.value = _temp.serial !== undefined && _temp.serial.value !== '' ? _temp.serial.value : ''
        this.form.expires_from.value = _temp.expires_from !== undefined && _temp.expires_from.value !== '' ? _temp.expires_from.value : ''
        this.form.expires_to.value = _temp.expires_to !== undefined && _temp.expires_to.value !== '' ? _temp.expires_to.value : ''
        this.form.tipoCert.value = _temp.tipoCert !== undefined && _temp.tipoCert.value !== '' ? _temp.tipoCert.value : ''
      }
    },
    // eslint-disable-next-line camelcase
    watchFormHandler: function ({ expires_from, expires_to }) {
      // eslint-disable-next-line camelcase
      // if (created_at_from !== undefined && moment(created_at_from.value).isValid()) {
      //   this.form.created_at_from.value = moment(created_at_from.value).format('YYYY-MM-DD')
      // } else {
      //   this.form.created_at_from.value = ''
      // }
      // eslint-disable-next-line camelcase
      // if (created_at_to !== undefined && moment(created_at_to.value).isValid()) {
      //   this.form.created_at_to.value = moment(created_at_to.value).format('YYYY-MM-DD')
      // } else {
      //   this.form.created_at_to.value = ''
      // }
      // eslint-disable-next-line camelcase
      if (expires_from !== undefined && moment(expires_from.value).isValid()) {
        this.form.expires_from.value = moment(expires_from.value).format('YYYY-MM-DD')
      } else {
        this.form.expires_from.value = ''
      }
      // eslint-disable-next-line camelcase
      if (expires_to !== undefined && moment(expires_to.value).isValid()) {
        this.form.expires_to.value = moment(expires_to.value).format('YYYY-MM-DD')
      } else {
        this.form.expires_to.value = ''
      }
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        // created_at_from: { label: 'Creado desde', value: '' },
        // created_at_to: { label: 'Creado hasta', value: '' },
        expires_from: { label: 'Expira desde', value: '' },
        expires_to: { label: 'Expira hasta', value: '' },
        name: { label: 'Nombre', value: '' },
        serial: { label: 'Serial', value: '' },
        tipoCert: { label: i18n.t('certificates.type'), value: '' },
      }
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>
